import { CompassIcon, OctagonAlertIcon } from "lucide-react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router";
import { messageOf } from "@/api/problem";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/display";

export function NotFound() {
  return (
    <EmptyState icon={<CompassIcon />} title="Page introuvable" className="flex-1">
      <p>Cette adresse ne mène nulle part sur seamap.io.</p>
      <Button asChild variant="outline" size="sm" className="mt-3">
        <Link to="/">Revenir à la carte</Link>
      </Button>
    </EmptyState>
  );
}

export function RouteError() {
  const e = useRouteError();
  const text = isRouteErrorResponse(e) ? `${e.status} ${e.statusText}` : messageOf(e);
  return (
    <div className="flex h-dvh items-center justify-center p-6">
      <EmptyState icon={<OctagonAlertIcon />} title="Une erreur a interrompu la page">
        <p className="font-mono text-xs">{text}</p>
        <Button variant="outline" size="sm" className="mt-3" onClick={() => window.location.assign("/")}>
          Recharger
        </Button>
      </EmptyState>
    </div>
  );
}
